import ApplicationComponent from "legacy/ApplicationComponent"
import {
  formatPriceForCategory,
  humanize,
  isListedPumpPrice,
  metaFuel,
} from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class PosItemList extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.handleAddToCart = this.handleAddToCart.bind(this)
    this.borderClass = this.borderClass.bind(this)
    this.renderButtons = this.renderButtons.bind(this)
    this.renderSection = this.renderSection.bind(this)
    this.listedPumpPriceItems = this.listedPumpPriceItems.bind(this)
    this.standardGroupedItems = this.standardGroupedItems.bind(this)
  }

  handleAddToCart(item) {
    const cartItem = { ...item }
    cartItem.quantity = metaFuel(cartItem.category) ? "" : 1
    this.props.handleAddToCart(cartItem)
  }

  borderClass(items, item) {
    if (items.length === 1) {
      return "rounded p-2 border"
    } else if (item === items[items.length - 1]) {
      return "rounded-b border-b px-2 pb-2"
    } else if (item === items[0]) {
      return "rounded-t border-t p-2"
    } else {
      return "px-2 pb-2"
    }
  }

  renderButtons(item) {
    if (this.props.cart.items.find((cartItem) => cartItem.id === item.id)) {
      return (
        <div className="m-0 flex w-full justify-end">
          <button
            type="button"
            className="btn btn-secondary btn-sm w-full flex-initial md:w-auto"
            onClick={() => this.props.handleRemoveFromCart(item)}
          >
            Remove
          </button>
        </div>
      )
    } else {
      return (
        <div className="m-0 flex justify-end">
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => this.handleAddToCart(item)}
          >
            Add
          </button>
        </div>
      )
    }
  }

  renderSection(category, items) {
    const html = []
    if (items && items.length) {
      html.push(
        <div key={category} className="grid grid-cols-2">
          <h3 className="text-base font-semibold">{humanize(category)}</h3>
          {category === "listed_pump_prices" &&
            this.props.listedPumpPriceLastUpdatedAt && (
              <p className="mt-5 text-right text-xs text-gray-700">
                Last updated on {this.props.listedPumpPriceLastUpdatedAt}
              </p>
            )}
        </div>
      )
    }

    if (items) {
      items.forEach((item) =>
        html.push(
          <div
            className={`border-l border-r bg-white ${this.borderClass(
              items,
              item
            )}`}
            key={item.id}
          >
            <div className="grid grid-cols-5 items-center">
              <p className="col-span-2 m-0">{humanize(item.name)}</p>
              <div className="m-0 text-center">
                {formatPriceForCategory(item.unitPrice, item.category)}
              </div>
              <p className="m-0 text-center">
                {this.props.renderTaxRate(item)}
              </p>
              {this.renderButtons(item)}
            </div>
            {item === items[items.length - 1] ? (
              ""
            ) : (
              <hr className="m-0 mt-2 bg-gray-200" />
            )}
          </div>
        )
      )
    }

    return html
  }

  listedPumpPriceItems() {
    return this.props.posItems.filter((item) => isListedPumpPrice(item))
  }

  standardGroupedItems() {
    const standardItems = this.props.posItems.filter(
      (item) => !isListedPumpPrice(item)
    )

    // Create our own groupBy implementation
    return standardItems.reduce((result, item) => {
      const category = item.category
      if (!result[category]) {
        result[category] = []
      }
      result[category].push(item)
      return result
    }, {})
  }

  render() {
    return (
      <div>
        <h2 className="sr-only">Select POS Items</h2>
        <div>
          <div className="grid h-9 grid-cols-5 bg-gray-200 pt-2">
            <p className="col-span-2 m-0 pl-4 text-sm font-semibold">Name</p>
            <p className="m-0 text-center text-sm font-semibold">Price</p>
            <p className="m-0 text-center text-sm font-semibold">Tax</p>
          </div>
          {this.renderSection(
            "listed_pump_prices",
            this.listedPumpPriceItems()
          )}
          {this.props.categories.map((category) =>
            this.renderSection(category, this.standardGroupedItems()[category])
          )}
        </div>
      </div>
    )
  }
}

PosItemList.propTypes = {
  posItems: PropTypes.array.isRequired,
  cart: PropTypes.shape({
    items: PropTypes.array,
  }).isRequired,
  categories: PropTypes.array.isRequired,
  listedPumpPriceLastUpdatedAt: PropTypes.string,
  handleAddToCart: PropTypes.func.isRequired,
  handleRemoveFromCart: PropTypes.func.isRequired,
  renderTaxRate: PropTypes.func.isRequired,
}

PosItemList.defaultProps = {
  posItems: [],
  cart: { items: [] },
  categories: [],
  listedPumpPriceLastUpdatedAt: null,
}

export default PosItemList
